var map = {
	"./alert-fail.svg": [
		818378,
		818378
	],
	"./apple-store.png": [
		936498,
		936498
	],
	"./back.svg": [
		736203,
		736203
	],
	"./breadstick-tilted.png": [
		477461,
		477461
	],
	"./calendar.svg": [
		536933,
		536933
	],
	"./carside.svg": [
		585778,
		585778
	],
	"./cart.svg": [
		47503,
		47503
	],
	"./cash-icon.svg": [
		652763,
		652763
	],
	"./check-update.svg": [
		968763,
		968763
	],
	"./check.svg": [
		72716,
		72716
	],
	"./cs-bg-color-other.png": [
		412296,
		412296
	],
	"./cs-bg-restaurant.png": [
		408364,
		408364
	],
	"./cs-bg-vehicle-other.svg": [
		851971,
		851971
	],
	"./cs-ico-call.svg": [
		590317,
		590317
	],
	"./cs-ico-car.svg": [
		446874,
		446874
	],
	"./cs-ico-checkmark-sm.svg": [
		643047,
		643047
	],
	"./cs-ico-checkmark.svg": [
		840052,
		840052
	],
	"./cs-ico-direction.svg": [
		371487,
		371487
	],
	"./cs-ico-error.svg": [
		842744,
		842744
	],
	"./cs-ico-location.svg": [
		562728,
		562728
	],
	"./cs-ico-parking-board-sm.svg": [
		193870,
		193870
	],
	"./cs-ico-parking-board.svg": [
		225025,
		225025
	],
	"./cs-ico-red-right-arrow.svg": [
		672247,
		672247
	],
	"./cs-ico-time.svg": [
		687519,
		687519
	],
	"./cs-img-restaurant.jpg": [
		714487,
		714487
	],
	"./debit-card-icon.svg": [
		958429,
		958429
	],
	"./delivery-icon.svg": [
		360420,
		360420
	],
	"./done-mark.svg": [
		21729,
		21729
	],
	"./geo-trust@2x.png": [
		271293,
		271293
	],
	"./geo-trust@3x.png": [
		985502,
		985502
	],
	"./gift-icon.svg": [
		685246,
		685246
	],
	"./google-play.png": [
		326039,
		326039
	],
	"./help-icon.svg": [
		185381,
		185381
	],
	"./home-icon.svg": [
		101889,
		101889
	],
	"./in-restaurant.svg": [
		665351,
		665351
	],
	"./location.svg": [
		909566,
		909566
	],
	"./logo-mob.svg": [
		295267,
		295267
	],
	"./logo.svg": [
		261200,
		261200
	],
	"./logo_2021-01-29 (1)/logo.jpg": [
		872757,
		872757
	],
	"./logo_2021-01-29 (1)/logo@2x.jpg": [
		951520,
		951520
	],
	"./logo_2021-01-29 (1)/logo@3x.jpg": [
		601586,
		601586
	],
	"./mob-pay-unavlbl.svg": [
		419010,
		419010
	],
	"./next-icon.svg": [
		903720,
		903720
	],
	"./pay-check.png": [
		579268,
		579268
	],
	"./pay-pal.svg": [
		22239,
		22239
	],
	"./payatres-inactive.svg": [
		892370,
		892370
	],
	"./payatres.svg": [
		303788,
		303788
	],
	"./payonline-active.svg": [
		618591,
		618591
	],
	"./payonline.svg": [
		234746,
		234746
	],
	"./paypal-logo.png": [
		100115,
		100115
	],
	"./paypal-logo@2x.png": [
		417899,
		417899
	],
	"./paypal-logo@3x.png": [
		950851,
		950851
	],
	"./persona.svg": [
		279409,
		279409
	],
	"./radio.svg": [
		9434,
		9434
	],
	"./restaurant-icon.svg": [
		264352,
		264352
	],
	"./right-arrow.svg": [
		310824,
		310824
	],
	"./secure-card.svg": [
		692120,
		692120
	],
	"./success-icon.svg": [
		478039,
		478039
	],
	"./tick-mark-disabled.svg": [
		152569,
		152569
	],
	"./tick-mark-green.svg": [
		167411,
		167411
	],
	"./time.svg": [
		182701,
		182701
	],
	"./web-pay-unavlbl.svg": [
		87849,
		87849
	],
	"./works-leave.png": [
		137093,
		137093
	],
	"./works-pay.png": [
		936020,
		936020
	],
	"./works-scan.png": [
		885565,
		885565
	],
	"./works-url.png": [
		971253,
		971253
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1]).then(function() {
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = function() { return Object.keys(map); };
webpackAsyncContext.id = 660475;
module.exports = webpackAsyncContext;